import React from 'react'

import MarkerIcon from '@uniiverse/library/assets/icons/marker.svg'

import style from './event-location.css'

export const EventLocation = (props) => {
  const locationName = props.address

  if (!locationName) {
    return null
  }

  return (
    <div className={style.container}>
      <MarkerIcon />
      <div className={style.text}>{locationName}</div>
    </div>
  )
}
